
export function getFileLastModifiedDate(file) {
  const lastModified = file.lastModified || file.lastModifiedDate || new Date();
  const offset = new Date().getTimezoneOffset();
  return useDayjs()(lastModified).subtract(offset, 'minute').toISOString();
}

export function getClipLengthSeconds(clip) {
  const markers = (clip?.markers || [])
    .map(marker => Number(marker?.time))
    .filter(time => Number.isFinite(time))
    .sort((a, b) => a - b);

  if (markers.length < 2) {
    return null;
  }

  const length = Math.max(0, markers[markers.length - 1] - markers[0]);
  return Number.isFinite(length) ? length : null;
}

export function formatSecondsToVideoEditorTime(seconds) {
  if (!Number.isFinite(seconds)) {
    return '';
  }

  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  const millis = Math.floor((seconds % 1) * 1000);

  return `${String(minutes).padStart(2, '0')}:` +
    `${String(secs).padStart(2, '0')}.` +
    `${String(millis).padStart(3, '0')}`;
}

export function formatDuration(duration, showHours, showMs) {
  if (isNaN(duration)) {
    return;
  }

  //grab the time portion of an ISO date and split
  const flooredDuration = Math.floor(duration / 1000) * 1000;
  const parts = new Date(flooredDuration).toISOString().match(/(\d{2}:){2}\d{2}/)[0].split(':');

  //if no hours
  if (!showHours && parts[0] === '00') {
    parts.shift();

    //trim leading 0 of minutes when no hours
    if (parts[0].startsWith('0')) {
      parts[0] = parts[0].slice(1);
    }
  }

  let result = parts.join(':');

  if (showMs) {
    result += '.' + String(duration % 1000).padStart(3, '0');
  }

  return result;
}

export function getMonths() {
  return useDayjs().localeData().months();
}

export function getCenturySuffix(century) {
  const lastTwoDigits = century % 100;
  const lastDigit = century % 10;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${century}th Century`;
  }

  switch (lastDigit) {
    case 1:
      return `${century}st Century`;
    case 2:
      return `${century}nd Century`;
    case 3:
      return `${century}rd Century`;
    default:
      return `${century}th Century`;
  }
}

export function formatDurationToTimecode(ms, fps = 30) {
  const d = useDayjs().duration(ms);

  const hours = String(d.hours()).padStart(2, "0");
  const minutes = String(d.minutes()).padStart(2, "0");
  const seconds = String(d.seconds()).padStart(2, "0");

  // Calculate frames from the remaining milliseconds
  const frames = Math.floor((d.milliseconds() / 1000) * fps);
  const ff = String(frames).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}:${ff}`;
}
